import React from 'react'
import Galleries from '../../components/galleries/galleries.js'
import Layout from '../../layouts/index.js'

const array = [
  '006535',
  '006551',
  '006553',
  '007007',
  '007089',
  '007093',
  '007109',
  '007279',
  '007306',
  '007312',
  '007333',
  '007336',
  '007412',
  '008011',
  '008031',
]

const images = array.map((image) => {
  return (
    <figure>
      <img
        alt=""
        key={image}
        src={require('../../images/gallery/zambia/' + image + '.jpg')}
      />
    </figure>
  )
})

const Zambia = () => (
  <Layout>
    <section>
      <h1>Zambia</h1>
      {images}
      <Galleries />
    </section>
  </Layout>
)

export default Zambia
